import React from 'react'
import { css } from '@emotion/css'
import { RenderDialogProps } from '../../../../legacy-design-system/action/confirmation-action'
import { ConfirmationDialog } from '../../../../legacy-design-system/modal'
import { FetchResult } from 'react-apollo'
import { FormattedMessage } from 'react-intl'
import { Checkbox } from '../../../../legacy-design-system/checkbox'

interface Server {
  readonly id: string
  readonly name: string
}

interface DeleteDialogProps extends RenderDialogProps {
  readonly organizationID: string
  readonly servers: Server[]
  readonly deleteOperation: (
    deleteVulnerabilities: boolean
  ) => Promise<FetchResult<any> | void>
}

interface DeleteDialogState {
  readonly deleteVulnerabilities: boolean
}

export class ConfirmDeleteServerDialog extends React.Component<
  DeleteDialogProps,
  DeleteDialogState
> {
  constructor(props) {
    super(props)
    this.state = {
      deleteVulnerabilities: false
    }
  }
  public render() {
    const { isOpen, closeDialog, servers, deleteOperation } = this.props
    const count = servers.length
    return (
      <ConfirmationDialog
        size="medium"
        isOpen={isOpen}
        onCancel={closeDialog}
        onConfirm={async () => {
          closeDialog()
          await deleteOperation(this.state.deleteVulnerabilities)
        }}
        renderConfirmMessage={() => <FormattedMessage id="action_delete" />}
        renderCancelMessage={() => <FormattedMessage id="action_cancel" />}
        renderTitle={() => (
          <FormattedMessage
            id="plural_servers_deleteServers"
            values={{ count }}
          />
        )}
        renderBody={() => (
          <React.Fragment>
            <div
              className={css`
                margin-bottom: 15px;
              `}
            >
              <FormattedMessage
                id="variable_deleteServer_confirmation_react"
                values={{
                  count,
                  serverName: (
                    <strong>{servers.map((s) => s.name).join(', ')}</strong>
                  )
                }}
              />
            </div>
            <div>
              <FormattedMessage
                id="detail_servers_deleteReportedVulnsConfirmation_checkbox_react"
                values={{ count }}
              >
                {(label) => (
                  <Checkbox
                    label={label as any}
                    onChange={this.toggleDeleteVulnerabilities}
                    value={this.state.deleteVulnerabilities}
                    data-testid="delete-vulnerabilities-toggle"
                  />
                )}
              </FormattedMessage>
            </div>
          </React.Fragment>
        )}
      />
    )
  }
  private toggleDeleteVulnerabilities = (deleteVulnerabilities) => {
    this.setState({ deleteVulnerabilities })
  }
}
